import { FC } from 'react';
import { useSelector } from 'react-redux';

import { selectDictionary } from 'features/dictionaries/dictionariesSelectors';

import { RawDictionaryData } from 'types/dictionaries';

import { Dictionaries } from 'constants/enums';
import { FALLBACK_VALUE } from 'constants/uiSettings';

import styles from './LanguageWithLevel.module.scss';

interface LanguageWithLevelProps {
  langs: RawDictionaryData | null;
}

const levelClassMapping: Record<string, string> = {
  Advanced: styles.advanced,
  Beginner: styles.beginner,
  Intermediate: styles.intermediate,
  Native: styles.native,
  'Pre-Intermediate': styles.preIntermediate
};

const LanguageWithLevel: FC<LanguageWithLevelProps> = ({ langs }) => {
  const languageLevelOptions = useSelector(
    selectDictionary(Dictionaries.LanguageLevel)
  );

  const formattedLanguages = langs
    ? Object.keys(langs).map((language) => {
        const levelValue = langs[language];
        const levelLabel = languageLevelOptions.find(
          (option) => option.value === levelValue
        )?.label;

        const levelClassName = levelLabel
          ? levelClassMapping[levelLabel as string]
          : '';

        return (
          <div className={styles.languageItem} key={language}>
            <div className={styles.languageName}>
              {language.charAt(0).toUpperCase() +
                language.slice(1).toLowerCase()}
            </div>
            {levelLabel && (
              <div className={`${styles.languageLevel} ${levelClassName}`}>
                ({levelLabel})
              </div>
            )}
          </div>
        );
      })
    : FALLBACK_VALUE;

  return <div className={styles.container}>{formattedLanguages}</div>;
};

export default LanguageWithLevel;
